module.exports = __webpack_public_path__ + "img/gosedan-log.19955c0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/gosedan-log.png
// module id = 274
// module chunks = 0